module.exports = __webpack_public_path__ + "static/media/30.11fcb0fa.jpg";